query allFootballPlayers(
  $first: Int
  $offset: Int
  $filter: FootballPlayerWithTeamFilter
  $condition: FootballPlayerWithTeamCondition
) {
  players: allFootballPlayerWithTeams(
    first: $first
    offset: $offset
    filter: $filter
    condition: $condition
  ) {
    nodes {
      teams
      player {
        name
        source
        playerIndex
        position
        playerId
      }
    }
    totalCount
  }
}
